import { useNavigate } from "react-router-dom";
import { FormWrapper } from "../../components/form-wrapper";
import { useFormState } from "../../components/context/hooks/useFormState";
import { useForm } from "react-hook-form";
import { ControlledCheckbox } from "../../components/form/controlled-checkbox";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Markdown,
} from "component-library";

import { useTranslation } from "react-i18next";
import { usePraxis } from "../../praxis-config/praxis-context";
import { useLocalizedText } from "../../praxis-config/use-localized-text";
import { routeOfInfoPageOrSend } from "../8-info/info-page-routes";

export const AdditionalPaymentPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { config } = usePraxis();
  const legallyInsuredMarkdown = useLocalizedText(
    config.texts.additionalPaymentLegallyInsured,
  );
  const privateInsuredMarkdown = useLocalizedText(
    config.texts.additionalPaymentPrivateInsured,
  );
  const { updateFormState, formState } = useFormState();

  const { control, handleSubmit, getValues } = useForm<{
    additionalPayment: boolean;
  }>({
    defaultValues: {
      additionalPayment: formState.additionalPaymentAccepted || false,
    },
  });

  const onSubmit = () => {
    updateFormState({
      additionalPaymentAccepted: getValues().additionalPayment,
    });

    navigate(routeOfInfoPageOrSend(config.infoPages, 0));
  };

  return (
    <FormWrapper onSubmit={handleSubmit(onSubmit)}>
      <div className="flex flex-col">
        <span className="text-2xl font-light text-text-primary text-center mb-6">
          {t("pages.additional_payment.title")}
        </span>
        <Accordion>
          <AccordionSummary aria-controls="panel1-content" id="panel1-header">
            {t("pages.additional_payment.legally_insured.title")}
          </AccordionSummary>
          <AccordionDetails className="flex flex-col gap-3 text-md text-gray-700">
            <Markdown>{legallyInsuredMarkdown}</Markdown>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary aria-controls="panel2-content" id="panel2-header">
            {t("pages.additional_payment.privately_insured.title")}
          </AccordionSummary>
          <AccordionDetails className="flex flex-col gap-3 text-md text-gray-700">
            <Markdown>{privateInsuredMarkdown}</Markdown>
          </AccordionDetails>
        </Accordion>
        <div className="mt-10 w-full">
          <ControlledCheckbox
            control={control}
            name="additionalPayment"
            required
          >
            <span className="text-base font-normal">
              {t("pages.additional_payment.checkbox_label")}
            </span>
          </ControlledCheckbox>
        </div>
      </div>
    </FormWrapper>
  );
};
